import { render } from "./ClinicalLabComponent.vue?vue&type=template&id=32df55a6&scoped=true"
import script from "./ClinicalLabComponent.vue?vue&type=script&lang=js"
export * from "./ClinicalLabComponent.vue?vue&type=script&lang=js"

import "./ClinicalLabComponent.vue?vue&type=style&index=0&id=32df55a6&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32df55a6"]])

export default __exports__